import { Locations, PageSource, track, trackEvent } from '@mc/track-event'

export const trackHeroVideoAutoplayStarted = () =>
  track('Hero Video Autoplay Started', {
    location: Locations.HERO,
    page_source: PageSource.HOMEPAGE,
  })

export const trackScrollAffordanceClicked = (action: string) =>
  track('Learn More Scroll Affordance Clicked', {
    location: PageSource.HOMEPAGE,
    action,
  })

export const trackNewClassesViewed = () =>
  track('New Classes Section Viewed', {
    page_source: PageSource.HOMEPAGE,
  })

export const trackFeaturedTileClicked = (properties: Record<string, string>) =>
  track('New Classes Featured Tile Clicked', properties)

export const trackMadeForLifelongLearnerViewed = (title: string) =>
  track(`${title} Viewed`, {
    page_source: PageSource.HOMEPAGE,
  })

export const trackStartYourLearningJourneyViewed = () =>
  track('Start Your Learning Journey Viewed', {
    page_source: PageSource.HOMEPAGE,
  })

export const trackHomepageQuizModalViewed = () =>
  trackEvent('Homepage Quiz Modal Viewed', {
    location: Locations.QUIZ_MODAL,
    page_source: PageSource.HOMEPAGE,
  })

export const trackHomepageQuizModalClosed = (action: string) =>
  trackEvent('Homepage Quiz Modal Closed', {
    location: Locations.QUIZ_MODAL,
    page_source: PageSource.HOMEPAGE,
    action,
  })
